// Generated by purs version 0.15.15
import * as Data_Maybe from "../Data.Maybe/index.js";
var defaultDuration = /* #__PURE__ */ (function () {
    return {
        hours: Data_Maybe.Nothing.value,
        minutes: Data_Maybe.Nothing.value,
        seconds: Data_Maybe.Nothing.value,
        milliseconds: Data_Maybe.Nothing.value
    };
})();
export {
    defaultDuration
};
